import { createFileRoute } from '@tanstack/react-router';
import { PleriSkillsPage } from '../settings/skills/index';

export const Route = createFileRoute('/skills/')({
  component: PleriSkillsPage,
});
